module.exports = __webpack_public_path__ + "static/museums-2c344ef452613aee099786b7cc3f4746.jpg";